/* eslint-disable array-callback-return */

angular.module('app.services').factory('locationsGenericService', [
  function locationsGenericService() {
    let instance = {
      selectLocation: (allLocationList, selectedValue, event) => {
        const checked = event.target.checked
        if (selectedValue.locations) {
          selectedValue.locations.map(location => {
            location.isSelected = checked
            if (location.children && location.children.length > 0)
              assignSelectedLocationsChildren(location.children, checked)
            return location
          })
        }

        if (selectedValue.children && selectedValue.children.length > 0)
          assignSelectedLocationsChildren(selectedValue.children, checked)

        if (selectedValue.regionId) {
          const region = getLocationById(
            allLocationList,
            selectedValue.regionId
          )
          region.isSelected =
            checked === false
              ? getSiblingLocationById(region.locations, selectedValue.id)
              : checked
        }

        if (selectedValue.parentId) {
          let parentLocation = allLocationList
            .map(location => {
              if (location.locations) {
                const foundLocation = getLocationById(
                  location.locations,
                  selectedValue.parentId
                )

                // eslint-disable-next-line no-negated-condition
                return !foundLocation
                  ? location.locations
                      .map(child => {
                        if (child.children && child.children.length > 0)
                          return getLocationById(
                            child.children,
                            selectedValue.parentId
                          )
                      })
                      .find(location => location)
                  : foundLocation
              }
            })
            .find(location => location)

          parentLocation.isSelected =
            checked === false
              ? getSiblingLocationById(
                  parentLocation.children,
                  selectedValue.id
                )
              : checked

          if (parentLocation.regionId) {
            let region = getLocationById(
              allLocationList,
              parentLocation.regionId
            )
            region.isSelected = parentLocation.isSelected
              ? parentLocation.isSelected
              : checked === false
              ? getSiblingLocationById(region.locations, selectedValue.parentId)
              : checked
          }

          if (parentLocation.parentId) {
            const grandParentLocation = allLocationList
              .map(location => {
                if (location.locations) {
                  return getLocationById(
                    location.locations,
                    parentLocation.parentId
                  )
                }
              })
              .find(location => location)

            grandParentLocation.isSelected = parentLocation.isSelected
              ? parentLocation.isSelected
              : checked === false
              ? getSiblingLocationById(
                  grandParentLocation.children,
                  selectedValue.parentId
                )
              : checked

            if (grandParentLocation.regionId) {
              let region = getLocationById(
                allLocationList,
                grandParentLocation.regionId
              )
              region.isSelected = grandParentLocation.isSelected
                ? grandParentLocation.isSelected
                : checked === false
                ? getSiblingLocationById(
                    region.locations,
                    grandParentLocation.id
                  )
                : checked
            }
          }
        }

        selectedValue.isSelected = checked
      },
      makeCandidateLocationsHierarchy: (candidateLocations, allLocations) => {
        let allCandidateLocationsWithParent = []
        let allCandidateLocationsWithChildren = []

        candidateLocations = allLocations.filter(location =>
          candidateLocations.find(({id}) => location.id === id)
        )

        candidateLocations.forEach(location => {
          getAllCandidateLocationChildren(
            location,
            allLocations,
            allCandidateLocationsWithChildren
          )
          getAllCandidateLocationWithParents(
            location,
            allLocations,
            allCandidateLocationsWithParent
          )
        })

        allCandidateLocationsWithParent = [
          ...allCandidateLocationsWithChildren,
          ...allCandidateLocationsWithParent,
        ].filter((v, index, a) => a.findIndex(t => t.id === v.id) === index)

        const regionHierarchialList = instance.initialize(
          allCandidateLocationsWithParent,
          allCandidateLocationsWithParent,
          true
        )
        regionHierarchialList.sort((a, b) => (a.name > b.name ? 1 : -1))
        return [
          ...regionHierarchialList.filter(region => region.name === 'Europe'),
          ...regionHierarchialList.filter(region => region.name !== 'Europe'),
        ]
      },
      setIsSelectedChildrenLocation: (allLocationList, selectedLocations) => {
        allLocationList.forEach(region => {
          if (region.isSelected === true) {
            region.locations.forEach(location => {
              saveLocationWithNoChildren(location, selectedLocations)
            })
          }
        })
        return selectedLocations
      },

      initialize: (selectedLocations, allLocationList) => {
        instance.clearSelection(allLocationList, false)
        if (selectedLocations) {
          selectedLocations.map(selectedValue => {
            assignSelectedLocations(selectedValue, true, allLocationList)
          })
        }

        return parseLocationByRegion(allLocationList)
      },
      clearSelection: (allLocationList, selection) => {
        instance.locationSelection(allLocationList, selection)
      },
      locationSelection: (allLocationList, selection) => {
        allLocationList.forEach(region => {
          region.isSelected = selection
          if (region.locations) {
            region.locations.map(location => {
              try {
                location.isSelected = selection
                if (location.children && location.children.length > 0)
                  assignSelectedLocationsChildren(location.children, selection)
                return location
              } catch (error) {
                console.error(error)
              }
            })
          }
        })
      },
      selectOrDeselectAllLocations: (allLocationList, selection) => {
        instance.locationSelection(allLocationList, selection)
      },
    }

    return instance
  },
])

/** This function called when location exists and make selected locations checked in hierarchial way.
 * @param  {} selectedValue //Specific location
 * @param  {} checked  //true
 * @param  {} allLocationList // all locations list
 */
const assignSelectedLocations = (selectedValue, checked, allLocationList) => {
  const location = allLocationList.find(({id}) => selectedValue.id === id)
  if (location) {
    location.isSelected = checked
    location.country.region.isSelected = checked
    if (location.parent)
      assignSelectedLocations(location.parent, checked, allLocationList)
  }
}

/** This method get children of selected regions until location has no child when saving locations
 * @param  {} list
 * @param  {} selectedLocations
 */
const saveLocationWithNoChildren = (list, selectedLocations) => {
  if (list.isSelected === true && list.children && list.children.length > 0) {
    const subChildren = list.children.filter(
      subChild => subChild.isSelected === true
    )
    if (subChildren.length > 0) {
      subChildren.forEach(subChild => {
        saveLocationWithNoChildren(subChild, selectedLocations)
      })
    }
  } else if (list.isSelected === true) {
    selectedLocations.push(list)
  }
}

/** This method will find and return record of location by id
 * @param  {} list  either locations or location children
 * @param  {} id id
 */
const getLocationById = (list, id) => {
  return list.find(row => row.id === id)
}

/** This method will assign isSelected checked and unchecked of selected locations children
 * @param  {} list either locations or location children
 * @param  {} checked either checked true or falls
 */
const assignSelectedLocationsChildren = (list, checked) => {
  return list
    .map(location => {
      try {
        if (location.children && location.children.length > 0)
          assignSelectedLocationsChildren(location.children, checked)

        location.isSelected = checked
        return location
      } catch (error) {
        console.error(error)
      }
    })
    .filter(Boolean)
}

/** This method will find sibling of locations
 * @param  {} list either locations or location children
 * @param  {} id id
 */
const getSiblingLocationById = (list, id) => {
  return list.some(sibling => sibling.isSelected === true && sibling.id !== id)
}

/** This method parse location to make region with respected locations
 * @param  {} list // locationList
 */
function parseLocationByRegion(list) {
  const ids = [
    ...new Set(
      list
        .filter(row => row.country.region.supported === true)
        .map(row => row.country.region.id)
    ),
  ]
  const names = [
    ...new Set(
      list
        .filter(row => row.country.region.supported === true)
        .map(row => row.country.region.name)
    ),
  ]

  return names.map((name, index) => {
    const location = list.find(
      row =>
        row.country.region.id === ids[index] &&
        row.country.region.isSelected === true
    )
    return {
      id: ids[index],
      name: name,
      isSelected: location && location.isSelected ? location.isSelected : false,
      locations: locationsHierarchy(list, name, ids[index]),
    }
  })
}

/** This method will make hierarchial locations of specific region
 * @param  {} list locationList
 * @param  {} regionName specific region Name
 * @param  {} regionId specific region Id
 */
const locationsHierarchy = (list, regionName, regionId) => {
  const linearList = angular.copy(list)
  const locationsHierarchy = list
    .filter(
      row => row.country.region.name === regionName && row.parent === null
    )
    .map(location => {
      location.regionId = regionId
      regionLocationsHierarchy(linearList, location)
      // eslint-disable-next-line you-dont-need-lodash-underscore/omit
      return _.omit(location, ['country'])
    })
  locationsHierarchy.sort((a, b) => (a.name > b.name ? 1 : -1))
  const ukId = locationsHierarchy.find(item => item.name === 'United Kingdom')

  const uk = [
    ...locationsHierarchy.filter(item => item.parentId === ukId),
    ...locationsHierarchy.filter(region => region.name === 'United Kingdom'),
  ]
  const result = [
    ...uk,
    ...locationsHierarchy.filter(region => {
      return region.name !== 'United Kingdom' && region.parentId !== ukId
    }),
  ]

  return result
}

/** This method will make region location hierarchy
 * @param  {} list  locationList
 * @param  {} location specific location object
 */
const regionLocationsHierarchy = (list, location) => {
  if (location.regionId) location.children = []
  list
    .sort((a, b) => (a.name > b.name ? 1 : -1))
    .find(child => {
      delete child.country
      if (child.parent) {
        child.children = []
        childrenLocationsHierarchy(list, child)
        if (child.parent.id === location.id) {
          child.parentId = child.parent.id
          delete child.parent
          location.children.push(child)
        }
      }
    })
}

/** This method will make children location hierarchy
 * @param  {} list locationList
 * @param  {} child specific child object
 */
const childrenLocationsHierarchy = (list, child) => {
  list
    .sort((a, b) => (a.name > b.name ? 1 : -1))
    .find(subChild => {
      if (subChild.parent) {
        if (subChild.parent.id === child.id) {
          subChild.parentId = subChild.parent.id
          delete subChild.parent
          child.children.push(subChild)
        }
      }
    })
}

const getAllCandidateLocationWithParents = (
  location,
  allLocations,
  allCandidateLocationsWithParent
) => {
  if (!location.parent || location.parent === null) {
    allCandidateLocationsWithParent.push(location)
    return
  }

  const parentId = allLocations.findIndex(
    ({id}) => location.parent && location.parent.id === id
  )
  const parent = allLocations[parentId]

  allCandidateLocationsWithParent.push(location)

  location = Object.assign(parent)

  getAllCandidateLocationWithParents(
    location,
    allLocations,
    allCandidateLocationsWithParent
  )
}

const getAllCandidateLocationChildren = (
  location,
  allLocations,
  allCandidateLocationsWithChildren
) => {
  const parents = allLocations.filter(
    ({parent}) => parent && parent.id === location.id
  )

  if (
    parents.every(location =>
      allCandidateLocationsWithChildren.includes(location)
    )
  ) {
    return
  }

  allCandidateLocationsWithChildren.push(...parents)

  parents.forEach(location => {
    getAllCandidateLocationChildren(
      location,
      allLocations,
      allCandidateLocationsWithChildren
    )
  })
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/locations/locations.service.ctrl.js